import { render, staticRenderFns } from "./UninstallDetial.vue?vue&type=template&id=1afba254"
import script from "./UninstallDetial.vue?vue&type=script&lang=js"
export * from "./UninstallDetial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports